import React from 'react';
import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import ProblemSet from '../../components/ProblemSet';
import TopicNav from '../../components/TopicNav';
import Data from '../../data/LabsData';
import PageNotFound from '../PageNotFound';
import { normalizeExerciseTopics } from '../../utils/labNavigation';

export default function Exercises() {
  const { labId } = useParams();
  const data = Data[labId]?.content?.exercises;
  if (!data) return <PageNotFound />;

  const topics = normalizeExerciseTopics(data);
  let number = 1;
  return <Box component="form" aria-label="Exercises worksheet" onSubmit={event => event.preventDefault()}>
    <Typography variant="h2" component="h2" gutterBottom>Exercises</Typography>
    <Box sx={{ display: { md: topics.length > 1 ? 'grid' : 'block' }, gridTemplateColumns: '12rem minmax(0, 1fr)', gap: 4, alignItems: 'start' }}>
      <TopicNav sectionName="Exercises" topics={topics} />
      <Box sx={{ minWidth: 0 }}>
        {topics.map(topic => {
          const startNumber = number;
          number += topic.problemSet.problems.length;
          return <Box component="section" id={topic.id} key={topic.id} sx={{ mb: 6, scrollMarginTop: '6rem' }}>
            <Typography variant="h3" component="h3" gutterBottom>{topic.label}</Typography>
            <ProblemSet data={topic.problemSet} startNumber={startNumber} />
          </Box>;
        })}
      </Box>
    </Box>
  </Box>;
}
